import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { StandsFor } from "@/components/site/StandsFor";
import { OnAir } from "@/components/site/OnAir";
import { FeaturedStory } from "@/components/site/FeaturedStory";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Networks } from "@/components/site/Networks";
import { Manifesto } from "@/components/site/Manifesto";
// import { Team } from "@/components/site/Team"; // TEMP HIDDEN — restore to bring back Team section
import { Stories } from "@/components/site/Stories";
// import { Store } from "@/components/site/Store"; // TEMP HIDDEN — restore to bring back Store section
import { GetFeatured } from "@/components/site/GetFeatured";
import { Footer } from "@/components/site/Footer";
import { BackToTop } from "@/components/site/BackToTop";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || hash === "#top") return;
    const scroll = () => {
      const el = document.querySelector(hash);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -68 });
      else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 68, behavior: "smooth" });
    };
    const t = setTimeout(scroll, 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div data-testid="home-page" className="bg-black text-white min-h-screen">
      <Nav />
      <Hero />
      <StandsFor />
      <FeaturedStory />
      <OnAir />
      <EditorialMarquee items={["THE CENTRAL MEDIA NETWORK", "VISION · CULTURE · PROGRESS", "THE SOUND OF THE CULTURE"]} />
      <Networks />
      <EditorialMarquee items={["FASHION · MUSIC · ART · SPORTS · BUSINESS", "DOCUMENT · SUPPORT · ELEVATE"]} speed={30} />
      <Manifesto />
      {/* <Team /> */}{/* TEMP HIDDEN — restore to bring back Team section */}
      <Stories />
      {/* <Store /> */}{/* TEMP HIDDEN — restore to bring back Store section */}
      <GetFeatured />
      <Footer />
      <BackToTop />
    </div>
  );
}
